<template>
    <div class="deed-owner-edit-wrapper">
        <form autocomplete="off" method="post" :data-vv-scope="vScope" @keyup.enter="() => {return false;}" @submit.prevent="() => {return false;}">
            <div class="row" v-if="isNew">
                <div class="col-12">
                    <DeedOwnerLocation
                        v-model="form"
                        :additional="additional"
                        :panelCfg="panelCfg"
                        :vScope="vScope"
                        :readonlyForm="readonlyForm"
                        :baseTranslateID="baseTranslateID"
                        :cemeteries="cemeteries"
                    />
                </div>
            </div>
            <div class="row deed-owner-details-roles">
                <div class="col-12 col-sm-7 col-xl-8 deed-owner-details">
                    <DeedOwnerDetails
                        v-model="form"
                        :additional="additional"
                        :panelCfg="panelCfg"
                        :vScope="vScope"
                        :readonlyForm="readonlyForm"
                        :baseTranslateID="baseTranslateID"
                        :right_types="right_types"
                        :term_right_types="term_right_types"
                        :service_need_types="service_need_types"
                    />
                </div>
                <div class="col-12 col-sm-5 col-xl-4 deed-owner-roles">
                    <div class="adding" v-if="enableAddDeedOwnerHolder || enableAddDeedOwnerApplicant">
                        <div class="btn-deed-owner-holders" v-if="enableAddDeedOwnerHolder">
                            <PlusItem
                                :text="`${translateID}.buttons.holder.add`"
                                @add="onAddDeedOwnerHolder"/>
                        </div>
                        <div class="btn-deed-owner-applicant" v-if="enableAddDeedOwnerApplicant">
                            <PlusItem
                                :text="`${translateID}.buttons.applicant.add`"
                                @add="onAddDeedOwnerApplicant"/>
                        </div>
                    </div>

                    <div class="info-cards">
                        <div
                            v-if="allowViewDeedOwnerHolder"
                            class="deed-owner-holders">
                            <div
                                v-for="(holder, idx) in holders"
                                :key="`deed-owner-holder-${idx}`"
                                class="deed-owner-holder info-card">
                                <EntityInfoCard
                                    :headerText="`${translateID}.form.holder`"
                                    :btnAllow="allowViewDetailDeedOwnerHolder"
                                    :value="holder.entity"
                                    :extraInfo="holderInfoCard(holder)"
                                    @action="(data) => {allowViewDetailDeedOwnerHolder && onViewEntity(data, 'holders')}"
                                />

                                <div class="buttons">
                                    <!-- <button class="btn add-as-interment">
                                        <span class=""> ADD AS INTERMENT </span>
                                    </button> -->
                                    <button
                                        v-if="enableRemoveDeedOwnerHolder"
                                        class="btn remove-button"
                                        @click.prevent="onRemoveDeedOwnerHolder(holder)">
                                        <span class=""> {{ $t(`${translateID}.buttons.holder.delete`) }} </span>
                                    </button>
                                </div>
                            </div>

                                <!-- <div class="also-roi-applicant ng-star-inserted">
                                    <p class="also-title">Also:</p>
                                    <mat-chip role="option" color="primary" disableripple="" selected="false" class="mat-chip mat-focus-indicator mat-primary mat-standard-chip" tabindex="-1" aria-disabled="false">
                                    <div class="mat-chip-ripple"></div>Applicant
                                    </mat-chip>
                                </div>-->

                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import FormMixin from "./mixins/FormMixin";
import { isEmptyObject, customMergeDeep } from '@config/utils';
import { EVENTS } from '../../../shared/config/event-constants';

export default {
    mixins: [
        FormMixin,
    ],
    components: {
        DeedOwnerLocation: () => import(/* webpackChunkName: "cemeteries-deedowner-location" */ './elements/DeedOwnerLocation'),
        DeedOwnerDetails: () => import(/* webpackChunkName: "cemeteries-deedowner-details" */ './elements/DeedOwnerDetails'),
        PlusItem: () => import(/* webpackChunkName: "cemeteries-plusitem" */ './../../common/PlusItem'),
        EntityInfoCard: () => import(/* webpackChunkName: "cemeteries-plusitem" */ './../../common/EntityInfoCard'),
    },
    props: {
        eventDeedOwnerHolderViewDetail: {
            type: String,
            default: EVENTS.SHOW_MODAL_DETAIL_DEED_OWNER_HOLDER,
        },
        eventDeedOwnerApplicantViewDetail: {
            type: String,
            default: EVENTS.SHOW_MODAL_DETAIL_DEED_OWNER_APPLICANT,
        },
        eventEntityViewDetail: {
            type: String,
            default: EVENTS.SHOW_MODAL_DETAIL_ENTITY,
        },
        cemeteries: {
            type: Array,
            default: () => {return [];},
        },
        right_types: {
            type: Array,
            default: () => {return [];},
        },
        term_right_types: {
            type: Array,
            default: () => {return [];},
        },
        service_need_types: {
            type: Array,
            default: () => {return [];},
        },
    },
    data() {
        let idPanel = 'deed_owner';
        return {
            idPanel: idPanel,
        }
    },
    computed: {
        allowViewDeedOwnerHolder() {
            return this.actions?.holder?.show;
        },
        allowViewDetailDeedOwnerHolder() {
            return this.actions?.holder?.detail;
        },
        allowAddDeedOwnerHolder() {
            return this.actions?.edit && this.actions?.holder?.create;
        },
        allowRemoveDeedOwnerHolder() {
            return this.actions?.edit && this.actions?.holder?.delete;
        },
        allowViewDetailDeedOwnerApplicant() {
            return this.actions?.applicant?.detail;
        },
        allowAddDeedOwnerApplicant() {
            return this.actions?.edit && this.actions?.applicant?.create;
        },
        enableAddDeedOwnerHolder() {
            return this.allowAddDeedOwnerHolder;
        },
        enableRemoveDeedOwnerHolder() {
            return this.allowRemoveDeedOwnerHolder;
        },
        enableAddDeedOwnerApplicant() {
            return false;//this.allowAddDeedOwnerApplicant && !this.form.applicant_id;
        },
        isNew() {
            return !this.form?.id;
        },
        holders() {
            return this.form?.holders ?? [];
        },
    },
    methods: {
        holderInfoCard() {
            return [];
            // return [
            //     {key: 'start_type', name: 'deed_owner_holders.model.start_type', value: holder.start_type, order: 1},
            //     {key: 'start_at', name: 'deed_owner_holders.model.start_at', value: holder.start_at, order: 2},
            //     holder.end_type ? {key: 'end_type', name: 'deed_owner_holders.model.end_type', value: holder.end_type, order: 3} : null,
            //     holder.end_at ? {key: 'end_at', name: 'deed_owner_holders.model.end_at', value: holder.end_at, order: 4} : null,
            // ].filter(n => n);
        },
        onAddDeedOwnerHolder(params={}) {
            if(!this.enableAddDeedOwnerHolder) return;

            if(this.eventDeedOwnerHolderViewDetail) {
                this.$eventBus.publish(this.moduleCode, this.eventDeedOwnerHolderViewDetail, {
                    data: {
                        occupation_deed_owner_id: this.form?.id,
                    },
                    fnSave: (params = {}) => {
                        const {action, data, ...rest} = params;
                        if(!isEmptyObject(data)) {
                            let id = data?.id ?? null;
                            let entityId = data?.entity?.id ?? null;
                            if(!this.form.holders.find(h => id && h.id == id || entityId && h?.entity?.id == entityId)) {
                                this.form.holders.push(data);
                            }
                        }
                    }
                });
            }
        },
        onRemoveDeedOwnerHolder(holder = {}) {
            if(this.enableRemoveDeedOwnerHolder) {
                this.$root.$emit('openConfirmation', {
                    id: holder?.id,
                    data: holder,
                    text: this.$t(`${this.translateID}.msg.confirm-delete-holder`, {name: holder?.entity?.name}),
                    callback: (id, data = []) => {
                        this.form.holders.splice(this.form.holders.indexOf(data), 1);
                    }
                });
            }
        },
        onAddDeedOwnerApplicant(params={}) {
            if(!this.enableAddDeedOwnerApplicant) return;

            if(this.eventDeedOwnerApplicantViewDetail) {
                this.$eventBus.publish(this.moduleCode, this.eventDeedOwnerApplicantViewDetail, {
                    data: {
                        occupation_deed_owner_id: this.form?.id,
                    },
                });
            }
        },
        onViewEntity(params = {}, entityType = null) {
            if(this.eventEntityViewDetail) {
                this.$eventBus.publish(this.moduleCode, this.eventEntityViewDetail, {
                    data: {
                        ...params
                    },
                    callback: (params = {}) => {
                        const {action, data, ...rest} = params;
                        switch (action) {
                            case EVENTS.CREATED:
                            case EVENTS.UPDATED:
                                let entityId = data?.id ?? null;
                                let idxHolder = this.form[entityType].findIndex(h => h?.entity?.id == entityId);
                                if(idxHolder != -1) {
                                    customMergeDeep(this.form[entityType][idxHolder].entity, data);
                                }
                                break;
                            case EVENTS.DELETED:
                                break;
                            default:
                                break;
                        }
                    }
                });
            }
        }
    },
    watch: {
    }
}
</script>

<style lang="scss" scoped>
.deed-owner-edit-wrapper {
    .deed-owner-details-roles {
        .deed-owner-roles {
            display: flex;
            flex-direction: column;
            align-items: center;

            .adding {
                width: 100%;
                margin-bottom: 30px;

                > div:not(:last-child) {
                    margin-bottom: 20px;
                }
            }

            .info-cards {
                width: 100%;

                .info-card {
                    padding: 25px;
                    border-radius: 8px;
                    background: #f5f5f5;
                    width: 100%;
                    margin-bottom: 32px;
                    box-sizing: border-box;

                    .buttons {
                        display: flex;
                        margin-top: 28px;
                        justify-content: flex-end;

                        .btn {
                            margin: 0;
                            min-width: auto;
                            line-height: 36px;
                            padding: 0 16px;
                            outline: none;
                            font-size: 16px;
                            font-family: var(--city-medium-font-family);
                            color: var(--primary-color);

                            &:hover,
                            &:active,
                            &:focus {
                                text-decoration: none;
                                box-shadow: none;
                            }
                        }

                        .remove-button {
                            color: var(--delete-color);
                        }
                    }
                }
            }
        }
    }
}
</style>